export default __webpack_public_path__ + "static/media/hero-sustain.9ae4ffde.webp";